<template>
    <el-card shadow="never">
        <template #header>
          <div class="header">
            <el-breadcrumb class="breadcrumb" separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">工作台</el-breadcrumb-item>
              <el-breadcrumb-item>名片列表</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button type="primary" class="editbtn" @click="add">创建名片</el-button>
          </div>
        </template>
        <el-form :model="searchForm" inline label-width="120px">
          <el-form-item label="公司">
            <el-select
                v-model="searchForm.companyid"
                placeholder="请选择"
                style="width: 240px"
                >
                <el-option
                    v-for="item in baseData.companylist"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                />
                </el-select>
          </el-form-item>
          <el-form-item label="关键词">
            <el-input v-model="searchForm.words" placeholder="公司|名称|电话"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
    </el-card>
    <el-card shadow="never" style="margin-top:20px">
        <el-table row-key="id" v-loading="baseData.loading" border :data="tableData.data" style="width: 100%;margin-top: 10px;">
          <el-table-column prop="id" label="ID" width="60"/>
          <el-table-column prop="company" label="公司名称"/>
          <el-table-column prop="name" label="姓名" width="120"/>
          <el-table-column prop="phone" label="手机号码" width="120"/>
          <el-table-column prop="landline" label="座机" width="120"/>
          <el-table-column prop="address" label="公司地址" width="160"/>
          <el-table-column prop="introduction" label="简介" width="340">
            <template #default="scope">
              <el-popover
                placement="top"
                width="300"
                trigger="hover"
              >
                <div v-html="scope.row.introduction"></div>
                <template #reference>
                  <div style="width:100%;overflow:hidden;text-overflow: ellipsis; white-space: nowrap;">{{scope.row.introduction}}</div>
                </template>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="创建时间" width="180"/>
          <el-table-column prop="status" label="状态" width="90" >
            <template #default="scope">
              <el-text v-if="scope.row.status==0" type="danger">冻结</el-text>
              <el-text v-if="scope.row.status==1" type="warning">待绑定</el-text>
              <el-text v-if="scope.row.status==2" type="success">正常</el-text>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="140" >
            <template #default="scope">
              <el-button size="small" @click="edit(scope.row.id)" type="primary">编辑</el-button>
              <el-popconfirm
                confirm-button-text="是"
                cancel-button-text="否"
                title="确定删除吗?"
                @confirm="del(scope.row.id)"
              >
                <template #reference>
                  <el-button size="small" type="danger">删除</el-button>
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagestyle">
          <el-pagination
            v-model:current-page="searchForm.page"
            v-model:page-size="searchForm.limit"
            layout="sizes, prev, pager, next"
            :total="tableData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </el-card>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted } from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  import {useRouter} from 'vue-router'
  import { cardApi } from '@/api/card'
  import { companyApi } from '@/api/company'


  const router = useRouter()
  const searchForm:any = reactive({
    companyid:"",
    words:"",
    limit:10,
    page:1,
  })
  const baseData:any= reactive({
    loading:false,
    title:'',
    userbox:false,
    companylist:[],
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const search = () => {
    searchForm.page = 1
    getList()
  }
  const reset = () => {
    searchForm.page = 1
    searchForm.limit = 10
    searchForm.words = ""
    searchForm.companyid = ""
    getList()
  }
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const getCompanyList = () => {
    baseData.loading = true
    api.companyApi.list({limit:10000,page:1}).then((res:any)=>{
      baseData.loading = false
      let companylist = []
      if(res.code==200){
        for(var i in res.data.list){
            if(res.data.list[i].status==1){
                companylist.push(res.data.list[i])
            }
        }
        baseData.companylist = companylist
      }else{
        ElMessage.error(res.message)
      }
    })
  }

  const getList = () => {
    localStorage.setItem('cardspage',searchForm.page);
    localStorage.setItem('cardscompanyid',searchForm.companyid);
    localStorage.setItem('cardswords',searchForm.words);
    localStorage.setItem('cardslimit',searchForm.limit);
    baseData.loading = true
    api.cardApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        tableData.data = res.data.list
        tableData.total = res.data.total
        console.log(res.data.total)
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const add = () => {
    router.push("/cards/add");
  }
  const edit = (id:any) => {
    router.push("/cards/edit/"+id);
  }
  const del = (id:number) => {
    baseData.loading = true
    api.cardApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const defaultProps = {
    children: 'children',
    label: 'catagory_name',
    value: 'catagoryid',
  }
  onMounted(() => {
    searchForm.page = localStorage.getItem('cardspage') ? parseInt(localStorage.getItem('cardspage')) : 1;
    searchForm.companyid = localStorage.getItem('cardscompanyid') ? localStorage.getItem('cardscompanyid') : '';
    searchForm.words = localStorage.getItem('cardswords') ? localStorage.getItem('cardswords') : '';
    searchForm.limit = localStorage.getItem('cardslimit') ? parseInt(localStorage.getItem('cardslimit')) : 10;
    getList()
    getCompanyList()
  })
  </script>